<template>
  <v-container class="containerView screenBackground2">
    <v-row justify="center">
      <v-col cols="11">
        <h1 class="dashboard-title">
          Fleet Dashboard
        </h1>

        <v-progress-circular
          v-if="isLoading"
          indeterminate
          color="primary"
        />

        <div
          v-if="error"
          class="error-text"
        >
          {{ error }}
        </div>

        <FleetTable
          :key="vessels.length"
          @open-drawer="openVesselDrawer"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FleetTable from "./components/Table/FleetTable.vue";

export default {
  name: "Fleet",

  components: {
    FleetTable,
  },

  computed: {
    ...mapGetters("fleet", ["vessels", "isLoading", "error"]),

    fleet() {
      return this.$store.state.main.fleet || [];
    },
  },

  created() {
    this.fetchVesselsDashboard();
  },

  methods: {
    ...mapActions("fleet", ["fetchVesselsDashboard"]),

    openVesselDrawer(vesselName) {
      const vesselFromFleet = this.fleet.find((vessel) => vessel.vessel === vesselName);

      if (!vesselFromFleet) {
        return;
      }

      this.$store.commit("main/SET_SELECTED_VESSEL", vesselFromFleet);
      this.$store.commit("main/SET_DRAWER_OPEN", true);
    },
  },
};
</script>

<style scoped>
.containerView {
  padding: 62px 6px;
  font-family: "Roboto", monospace;
}

.dashboard-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.5rem;
  letter-spacing: 0.5px;
  margin-top: 16px;
  margin-bottom: 16px;
  text-transform: uppercase;
  text-shadow: 0 1px 3px #000000;
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif;
}

.screenBackground2 {
  background-color: #03334e;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: hidden;
}

.error-text {
  color: #ff8a80;
  font-size: 0.95rem;
  margin-top: 8px;
}
</style>
